import React from "react";

const OPTIONS = [
  // { key: "pending", label: "pending" },
  // { key: "accepted", label: "accepted" },
  // { key: "declined", label: "declined" },
  // { key: "inProcess", label: "inProcess" },
  // { key: "delivered", label: "delivered" },
  // { key: "completed", label: "completed" },
  // { key: "served", label: "served" },
  { key: "all", label: "All" }, // All excludes delivered
];

export default function StatusChips({ value, onChange, counts = {} }) {
  return (
    <div className="lo-chiprow" role="tablist" aria-label="Order filters">
      {OPTIONS.map(opt => {
        const active = value === opt.key;
        const count = counts?.[opt.key] ?? 0;
        return (
          <button
            key={opt.key}
            role="tab"
            aria-selected={active}
            className={`lo-chip ${opt.key} ${active ? "is-active" : ""}`}
            onClick={() => onChange(opt.key)}
          >
            <span>{opt.label}</span>
            <span className="lo-chip-count">{count}</span>
          </button>
        );
      })}
    </div>
  );
}
